module.exports = __webpack_public_path__ + "img/グループ 261.83f60e66.png";